import { createTheme } from "@mui/material/styles";

// Mirrors materialTheme.ts (the v4 theme). Kept in sync manually until the
// v4 theme is retired at the end of the migration (Phase 7).
const materialThemeV5 = createTheme({
  direction: "rtl",
  typography: {
    fontFamily: "'Assistant', sans-serif",
  },
  palette: {
    secondary: {
      main: "#ffc107",
    },
  },
  components: {
    // v5 defaults TextField/Select to variant="outlined"; v4 defaulted to
    // "standard". Set once here (MUI_MIGRATION_PLAN.md 5.9) rather than on
    // every converted component, to preserve the existing look.
    MuiTextField: { defaultProps: { variant: "standard" } },
    MuiFormControl: { defaultProps: { variant: "standard" } },
    MuiSelect: { defaultProps: { variant: "standard" } },
    MuiInputLabel: { defaultProps: { variant: "standard" } },
  },
});

export { materialThemeV5 };
